import SearchIcon from "@mui/icons-material/Search";
import { colors } from "healthex-common/colors";
import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
import { HXAutocomplete } from "./HXAutocomplete";
import { HXMenuButton } from "./HXMenuButton";
import { HXNumericTextField, HXTextField } from "./base.styles";
import { FlexColumnDiv, FlexRow, FlexRowDiv } from "./common.styles";
import CircularProgress from "@mui/material/CircularProgress";
import { HXButton } from "./HXButton";
import { HXDialogContent } from "./HXDialog";
import { HXDataGrid, HXDataGridCellContent } from "./HXDataGrid";
export const RecruitmentViewParent = styled.div `
    color: ${colors.black_main};

    .hideSearch {
        display: none;
    }

    .pre-cell > .MuiDataGrid-cellContent {
        white-space: pre-wrap;
    }
`;
export const SearchBar = styled.div `
    padding: 16px 0px;
    display: flex;
    gap: 40px;
`;
export const SearchBarInputs = styled(FlexRowDiv) `
    gap: 8px;
    flex-grow: 1;
`;
export const SearchTextField = styled(HXTextField) `
    flex-grow: 1;
`;
export const SearchTextFieldIcon = styled(SearchIcon) `
    font-size: 24px !important;
`;
export const SearchBarButtons = styled(FlexRowDiv) `
    margin-left: auto;
    gap: 16px;
    width: 168px;
    justify-content: flex-end;
    visibility: ${({ visible }) => (visible ? "visible" : "hidden")};
`;
export const ActionButton = styled(HXMenuButton).attrs({ secondary: true, startIcon: null, label: "" }) `
    border-color: ${colors.black_12};
    color: ${colors.black_lighter};
    padding: 8px;
    min-width: 0;

    &:hover {
        border-color: ${colors.black_lighter};
    }

    & .MuiButton-endIcon {
        margin: 0;
    }
`;
export const SuccessRequestConsentContentContainer = styled(FlexRow) `
    gap: 16px;
    align-items: center;
`;
export const PendingRequestConsentContentContainer = styled(SuccessRequestConsentContentContainer) `
    padding: 0px 24px 20px 24px;
`;
export const RequestingConsentTextContainer = styled.div `
    flex: 1 0 0;
    align-items: center;
`;
export const RequestingConsentCircularProgress = styled(CircularProgress).attrs({
    size: 64,
    sx: {
        color: colors.navy_main,
    },
}) `
    padding: 4px;
`;
export const RequestingConsentErrorList = styled.ul `
    margin: 0;
    padding-left: 30px;
`;
export const RecruitmentSelectAllBannerContainer = styled(FlexRow) `
    padding: 2px 16px;
    justify-content: center;
    align-items: center;
    background: ${colors.black_12};
`;
export const RecruitmentSelectAllBannerContent = styled(FlexRow) `
    gap: 8px;
    align-items: center;
`;
export const RecruitmentSelectAllBannerButton = styled(HXButton) `
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const ReminderConfigRow = styled(FlexRowDiv) `
    margin-left: 42px;
    gap: 16px;
    align-items: flex-start;
`;
export const VerticalCenterWrapper = styled(FlexRowDiv) `
    align-items: center;
    height: 40px; // height of sibiling input elements, but won't change if an error is shown, which is desired
`;
export const UpdateEveryTextField = styled(HXNumericTextField) `
    && {
        width: 140px;
    }
`;
export const UpdateUnitDropdown = styled(HXAutocomplete) `
    && {
        width: 120px;
    }
`;
export const ReminderOption = styled(FlexColumnDiv) `
    gap: 16px;
`;
export const ReminderDialogContent = styled(HXDialogContent) `
    display: flex;
    flex-direction: column;
    gap: 24px;
`;
export const RecruitmentDataGrid = styled(HXDataGrid) `
    margin-top: 16px;
`;
export const StatusDropdown = styled(HXAutocomplete) `
    width: 200px;
`;
export const PatientInfoTile = styled(FlexColumnDiv) `
    gap: 4px;
    padding: 12px;
    background-color: ${colors.navy_4};
    border-radius: 4px;
`;
export const ClickableLastActivityText = styled(HXDataGridCellContent) `
    text-decoration: underline;
    cursor: pointer;

    &:hover {
        opacity: 0.8;
    }
`;
export const ExternalIdCellContent = styled(HXDataGridCellContent) `
    word-break: break-all;
`;
